import React from "react"
import {Button} from "antd"
import classNames from "classnames"
import {Icon} from "components/Icons"
import styles from "./BaseButton.module.css"

export function AddCircleButton(props) {
    const {title, className, ...rest} = props

    return (
        <Button
            className={classNames(styles.baseAddCircleBtn, className || "")}
            shape="circle"
            icon={<Icon className={styles.iconPlus} icon="PLUS" color="#FFF" />}
            {...rest}
        />
    )
}
